// describes the bindings available to consumers of this component
import IComponentController = angular.IComponentController;

export interface IBaseSingleInputBindings {
    labelBinding: string;
    modelBinding: string;
    validationBinding: string;
    onBackBinding: () => any;
    onNextBinding: () => any;
}

export abstract class BaseSingleInputComponent implements ng.IComponentOptions {
    public bindings: any;
    public controller: any;
    public templateUrl: string;

    protected abstract getController(): typeof BaseSingleInputComponentController;

    protected abstract getTemplateUrl(): string;

    protected abstract getBindings(): any;

    constructor() {
        this.controller = this.getController();
        this.templateUrl = this.getTemplateUrl();
        const bindings = this.getBindings();
        // apply default bindings
        bindings.labelBinding = '@';
        bindings.modelBinding = '=';
        bindings.validationBinding = '@';
        bindings.onBackBinding = '&';
        bindings.onNextBinding = '&';
        this.bindings = bindings;
    }
}

// internal interface between the component and the controller -- this is the controller's API
interface IBaseSingleInputComponentController extends IBaseSingleInputBindings {
    goNext(): void;
    goBack(): void;
}

// tslint:disable-next-line:max-classes-per-file
export abstract class BaseSingleInputComponentController implements IBaseSingleInputComponentController, IComponentController {
    public labelBinding: string;
    public modelBinding: any;
    public validationBinding: string;

    public onBackBinding: () => any;
    public onNextBinding: () => any;

    public static $inject = ['$scope', 'ValidationService'];

    constructor(protected $scope: any, public validationService: any) {
    }

    // $onInit is part of the angular component lifecycle and is the recommended hook for running controller initialization logic
    public $onInit(): void {
        // this $scope / validationOptions setup is here so that the validation service works correctly even though we create this form over and over with the same name
        // https://github.com/ghiscoding/angular-validation/wiki/Isolated-Scope
        this.validationService = new this.validationService();
        this.validationService.setGlobalOptions({isolatedScope: this.$scope, controllerAs: this, debounce: 1, hideErrorUnderInputs: true});
        this.activate();
    }

    protected activate() {
        // this is empty on purpose
        // its only purpose is to allow for it to be overridden so that child classes can execute code upon activation of the controller
    }

    public goNext(): void {
        if (angular.isDefined(this.validationBinding) && this.validationBinding !== '') {
            // if there's no validation binding, no need to check validation
            // this also solves an issue where if the markup doesn't contain any angular-validation declarations, calling checkFormValidity throws an exception
            if (this.validationService.checkFormValidity(this.$scope.quoteWizardForm) === false) {
                return;
            }
        }
        if (this.onNextBinding)
            this.onNextBinding();
    }

    public goBack(): void {
        if (this.onBackBinding)
            this.onBackBinding();
    }
}
